import React from 'react';
import { useAppSelector } from '../../hooks/redux';

const TokenBalance: React.FC = () => {
  const { balance } = useAppSelector((state) => state.loyalty);

  return (
    <div className="bg-gradient-to-br from-[var(--color-brand-primary)] to-[var(--color-brand-600)] text-white p-6 rounded-lg shadow-lg">
      <h3 className="text-sm font-medium opacity-90 mb-2">NEO Token Balance</h3>
      <p className="text-4xl font-bold mb-2">{balance.toLocaleString()}</p>
      <p className="text-sm opacity-75">Available for rewards and participation</p>
    </div>
  );
};

export default TokenBalance;

